import TopNav from "./TopNav";
import BottomTabBar from "./BottomTabBar";
import Footer from "./Footer";
import OwnerModeBanner from "./OwnerModeBanner";
import MaintenanceBanner from "@/components/MaintenanceBanner";
import { useAuth } from "@/contexts/AuthContext";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const hasBottomBar = user && user !== false;
  // Hide footer on the focused workspace so the photo is undistracted
  const hideFooter = loc.pathname.startsWith("/visualiser/p/");
  // Phase 5 · homeowner /shared/:token pages render their own compact header
  // and must NOT show the ColourMatch app chrome (top nav, footer, tab bar).
  const isShared = loc.pathname.startsWith("/shared/");
  // ColourMatch Pro professional workspace (Redesign 2026-02-09) has its own
  // shell (header + left rail). Suppress the homeowner-facing app chrome so
  // painters see a single branded ColourMatch Pro surface.
  const isPro = loc.pathname === "/pro" || loc.pathname.startsWith("/pro/");
  // Visualiser workspace refresh (LF-005) uses a full-screen application shell.
  const isWorkspace = loc.pathname.startsWith("/visualiser/p/");
  if (isWorkspace) {
    // Fully isolated app shell — banners stack above, workspace fills the rest,
    // no page scroll possible.
    return (
      <div className="h-screen flex flex-col overflow-hidden bg-background">
        <MaintenanceBanner />
        <OwnerModeBanner />
        <div className="flex-1 min-h-0 flex flex-col">{children}</div>
      </div>
    );
  }
  if (isShared || isPro) {
    return (
      <div className="min-h-screen bg-background">
        <MaintenanceBanner />
        <OwnerModeBanner />
        {children}
      </div>
    );
  }
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <MaintenanceBanner />
      <OwnerModeBanner />
      <TopNav />
      <main className={`flex-1 ${hasBottomBar ? "pb-20 md:pb-0" : ""}`}>{children}</main>
      {!hideFooter && <Footer />}
      <BottomTabBar />
    </div>
  );
}
